// extracted by mini-css-extract-plugin
export default {"customizeOffset":"customize-offset__PwImG8ot","input":"input__szVSFf_0","startOfInterval":"start-of-interval__KUHIGfVu","text":"text__RozslhIN"};